// LGPD: o painel mostra conversa, telefone e CPF de cliente final — nada
// disso vai pro Sentry. O SDK já vem com sendDefaultPii desligado (sem IP,
// cookie, usuário); aqui fica o que ele manda mesmo assim:
// - breadcrumb de console: o argumento do console.* costuma ser o payload
//   inteiro (mensagem, contato) — descartado;
// - URL com query string (busca de contato por nome/telefone, filtros) em
//   breadcrumb de xhr/fetch/navegação e no request do evento — só o caminho.
// - props do componente que estourou: o @sentry/vue liga `attachProps` por
//   padrão e grava `vm.$props` em `contexts.vue.propsData` — num componente
//   de conversa isso é a mensagem e o contato inteiros. Desligado no init e
//   `propsData` apagado no beforeSend (se alguém religar ou o SDK mudar o
//   default, o scrub ainda segura); o resto de `contexts.vue` fica.
// Ids no caminho ficam: é com eles que se reproduz o erro na triagem.
// Irmão do scrubEvent do webchat (shared/helpers/errorReport.js), que é mais
// agressivo porque lá a tela é do cliente.

const stripQuery = url =>
  typeof url === 'string' ? url.split(/[?#]/)[0] : url;

const URL_FIELDS = ['url', 'from', 'to'];

export const scrubBreadcrumb = breadcrumb => {
  if (breadcrumb.category === 'console') return null;
  if (!breadcrumb.data) return breadcrumb;

  const data = { ...breadcrumb.data };
  URL_FIELDS.forEach(field => {
    if (field in data) data[field] = stripQuery(data[field]);
  });
  return { ...breadcrumb, data };
};

export const scrubEvent = event => {
  const scrubbed = { ...event };
  delete scrubbed.user;
  // Só as props saem: componentName/lifecycleHook/trace são o que diz ONDE
  // estourou na triagem, e não carregam dado de cliente.
  if (scrubbed.contexts?.vue && 'propsData' in scrubbed.contexts.vue) {
    const { propsData, ...vue } = scrubbed.contexts.vue;
    scrubbed.contexts = { ...scrubbed.contexts, vue };
  }
  if (scrubbed.request) {
    const agent = scrubbed.request.headers?.['User-Agent'];
    scrubbed.request = {
      url: stripQuery(scrubbed.request.url),
      ...(agent ? { headers: { 'User-Agent': agent } } : {}),
    };
  }
  return scrubbed;
};

// Opções comuns do Sentry.init do painel (dashboard e v3).
export const privacyOptions = {
  sendDefaultPii: false,
  attachProps: false,
  beforeBreadcrumb: scrubBreadcrumb,
  beforeSend: scrubEvent,
};
